import { IsArray, IsBoolean, IsNotEmpty, IsOptional, IsString, Length, ValidateNested } from 'class-validator';
import { CreateSurveyQuestionDto, CreateSurveyTranslatedQuestionDto } from './create-survey-quetion.dto';
import { Type } from 'class-transformer';

export class UpdateSurveyTemplateTranslateDto {
	@IsNotEmpty()
	_id: string;

	@IsNotEmpty()
	mainTemplateId: string;

	@IsString()
	@Length(1)
	language: string;
	
	@IsBoolean()
	isDefault: string;

	@IsBoolean()
	isFinished: boolean;

	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateSurveyTranslatedQuestionDto)
	questions?: Array<CreateSurveyTranslatedQuestionDto>;
}

